import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import { useAuth } from './auth';

export const CHAVE_CONTAS_AGUARDANDO = ['usuarios-aguardando-contagem'] as const;

/**
 * Quantas contas entraram com a Microsoft sem estar no cadastro e aguardam um administrador.
 * Só consulta para quem pode gerenciar usuários; para os demais é sempre zero.
 */
export function useContasAguardando(): number {
  const { pode } = useAuth();
  const podeGerenciar = pode('usuario:gerenciar');

  const consulta = useQuery({
    queryKey: CHAVE_CONTAS_AGUARDANDO,
    queryFn: () => api.get<{ aguardandoLiberacao: number }>('/users/pending-count'),
    enabled: podeGerenciar,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });

  return podeGerenciar ? (consulta.data?.aguardandoLiberacao ?? 0) : 0;
}
